import * as Font from 'expo-font';
import * as React from 'react';
import { Asset } from 'expo-asset';
import { FontAwesome, Ionicons, MaterialIcons } from '@expo/vector-icons';
import { Image } from 'react-native';
import { ImageResource } from '../types/types';
import { fonts, images } from '../assets/images/index';


export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    const loadResourcesAndDataAsync = async () => {
      try {
        await Font.loadAsync({
          ...Ionicons.font,
          ...MaterialIcons.font,
          ...FontAwesome.font,
          ...fonts,
        });
        if (images) {
          await cacheImages(images);
        }
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
      }
    };
    if (!isLoadingComplete) {
      loadResourcesAndDataAsync();
    }
  }, []);


  return isLoadingComplete;
}

function cacheImages(images: ImageResource[]): Promise<void[]> {
  return Promise.all(
    images.map(
      (image: ImageResource): Promise<void> => {
        return typeof image === 'string' ? Image.prefetch(image) : Asset.fromModule(image).downloadAsync();
      },
    ),
  );
}
